<template>
  <div class="wrapper flex-column align-center justify-center full-parent">
    <div class="info-block">
      <slideInfo
        title="十大服务保障#坐月子没有后顾之忧"
        desc="全方位解决您的顾虑"
        align="center"
        :divider="false"
      />
    </div>
    <div class="service-block">
      <div
        v-for="(item, index) of serviceList"
        :key="index"
        class="service-item"
      >
        <img
          class="service-bg full-parent skeleton swiper-lazy"
          draggable="false"
          :data-src="item.img"
        />
        <div class="service-info full-parent">
          <div class="title">{{ item.title }}</div>
          <div class="desc">{{ item.desc }}</div>
          <mpPopover placement="top">
            <button class="button flex-row align-center">
              <div class="text">选月嫂</div>
              <img
                draggable="false"
                class="icon"
                src="~@/assets/images/home_pic7_icon_leave@2x.png"
              />
            </button>
          </mpPopover>
        </div>
      </div>
    </div>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";
import mpPopover from "../../../../components/mp-popover/mp-popover.vue";

export default defineComponent({
  components: { mpPopover, slideInfo },

  data() {
    return {
      serviceList: [
        { title: '健康保障', desc: '联合深圳【第一健康中心】，额外提供乙肝、艾滋、梅毒等健康检查项目', img: 'https://mm2015.mamalaile.com.cn/d985dd1118154480a4f57dfae4ecdda5.png' },
        { title: '财产保障', desc: '服务过程中出现因服务人员造成客户财产损失或丢失，平台先行赔付', img: 'https://mm2015.mamalaile.com.cn/d60cb8708a16480a5abe998fdd920187.png' },
        { title: '安全保障', desc: '联合国内知名保险太平洋保险，免费为月嫂提供服务保险', img: 'https://mm2015.mamalaile.com.cn/f836bd079553d98c4a0a35895458da56.png' },
        { title: '人员可靠保障', desc: '联合国内知名在线背景调查平台【知了】，深度彻查所有月嫂背景信息', img: 'https://mm2015.mamalaile.com.cn/2e62b39905d52c1b9f897575a1685640.png' },
        { title: '自营保障', desc: '自营月嫂，服务有保障。区别于中介模式的三方协议，您与妈妈来了签订的是甲乙双方合同，全面保障您的服务。', img: 'https://mm2015.mamalaile.com.cn/bd5bc1b5cc34b7d1c528313a6dc8de0d.png' },
        { title: '档期保障', desc: '预留预产期前后5天作为月嫂档期缓冲期，给宝宝自由的选择权', img: 'https://mm2015.mamalaile.com.cn/50fa731d1f06de711c0198b795a5be42.png' },
        { title: '24小时售后保障', desc: '预产期超过缓冲期？服务不满意？售后团队24小时在线解决', img: 'https://mm2015.mamalaile.com.cn/f9dde25ee4b692e81a0979562bcd89f2.png' },
        { title: '特殊保障', desc: '如因不可抗力的原因造成宝宝产前或产后意外，平台退全额定金', img: 'https://mm2015.mamalaile.com.cn/08cc0d3fee52777e51f11afbe24ca9b7.png' },
        { title: '母乳喂养保障', desc: '力争每位妈妈都能实现母乳喂养，专家团队线上线下鼎力相助', img: 'https://mm2015.mamalaile.com.cn/a1761abaf5bbe0527c997e0500fae5ba.png' },
        { title: '团队服务保障', desc: '您请的不止一名月嫂，月子顾问、以后专家、母乳顾问，售后团队等竭诚为您服务', img: 'https://mm2015.mamalaile.com.cn/721e2b7a69562d82be6584b8bcfe7521.png' },
      ],
      decorateList: [
        { position: 'top-right', url: require('/src/assets/images/home_pic7_bg1@2x.png'), width: 34.27 },
        { position: 'bottom-left', url: require('/src/assets/images/home_pic3_bg1@2x.png'), width: 37.76 },
      ]
    };
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .info-block {
    margin-bottom: 2.66vw;
  }

  .service-block {
    @serviceItemWidth: 18.8vw;
    @serviceItemHeight: 13.54vw;
    @serviceItemMarginX: 1.51vw;
    @serviceItemMarginY: 1.56vw;
    grid-template-columns: repeat(5, @serviceItemWidth);
    grid-template-rows: repeat(2, @serviceItemHeight);
    gap: @serviceItemMarginX @serviceItemMarginY;
    width: 100%;
    display: grid;
    position: relative;

    .service-item {
      position: relative;
      display: inline-grid;

      .service-bg {
        object-fit: cover;
      }

      .service-info {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 0;
        padding: 1.82vw 2.08vw 0;
        color: white;
        background: @color-primary url("~@/assets/images/home_pic7_card@2x.png")
          no-repeat 100% 0;
        background-size: 7.76vw auto;
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.3s ease, height 0.3s ease;

        .title {
          font-size: 1.56vw;
          line-height: 2.19vw;
          margin-bottom: 0.78vw;
          font-family: @font-ab;
        }

        .desc {
          font-size: 1.04vw;
          line-height: 1.56vw;
          text-align: justify;
          margin-bottom: 0.78vw;
        }

        .button {
          .text {
            position: relative;
            font-size: 0.78vw;
            margin-right: 0.26vw;
            line-height: 1.09vw;

            &::after {
              content: "";
              width: 100%;
              height: 1px;
              background-color: white;
              position: absolute;
              left: 0;
              bottom: 0;
            }
          }

          .icon {
            width: 0.94vw;
            height: auto;
          }
        }
      }

      &:hover {
        .service-info {
          height: @serviceItemHeight;
          opacity: 1;
          pointer-events: auto;
        }
      }
    }
  }
}
</style>